import { Skeleton } from '@playbooks/ui/components/skeleton';
import { Table, TableBody, TableCell, TableRow } from '@playbooks/ui/components/table';
import { cn } from '@playbooks/ui/lib/utils';
import { buildArray } from '@playbooks/utils';

import type { SkeletonCountProps } from './types';

const TableSkeleton = ({ count = 3, className = '' }: SkeletonCountProps) => {
	// Computed
	const columns = ['w-14', 'w-20', 'w-36', 'w-24', 'w-28', 'ml-auto w-8'];

	// Render
	return (
		<Table aria-label='Loading table data' aria-busy='true' className={className}>
			<TableBody className='[&_tr]:hover:bg-transparent!'>
				{buildArray(count).map((_, rowIndex) => (
					<TableRow key={rowIndex} aria-hidden='true'>
						{columns.map((width, columnIndex) => (
							<TableCell key={columnIndex} className='h-12 px-4'>
								<Skeleton className={cn('h-4', width)} />
							</TableCell>
						))}
					</TableRow>
				))}
			</TableBody>
		</Table>
	);
};

export { TableSkeleton };
